import { Component, OnInit } from '@angular/core';
import { Dataset } from 'src/app/components/abcis-table/abcis-table.component';
import { ABCisApi, ApiService } from 'src/app/handlers/apiHandler.service';
import { LoggerService } from 'src/app/handlers/logger.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-ocr-flow-dashboard',
  standalone: false,
  templateUrl: './ocr-flow-dashboard.component.html',
  styleUrls: ['./ocr-flow-dashboard.component.scss']
})
export class OcrFlowDashboardComponent implements OnInit {
  pdfWidth: number = null;

  runningDataSet: Dataset[] = [{label: '', value: undefined}, {label: 'Yes', value: true}, {label: 'No', value: false}];
  flow: flowJob[] = [];

  jobSet: Dataset[] = [];
  clientSet: Dataset[] = [];
  channelSet: Dataset[] = [];

  allowedChannels: number[] = [ 2 ];

  constructor(private apiHandler: ApiService,
    private logger: LoggerService,
    private toastr: ToastrService) { }

  ngOnInit() {
    this.ConfigureFlow();
  }

  ConfigureFlow() {
    this.apiHandler.getABCisRequest<Dataset[]>(ABCisApi.Support, 'client/lookup').then((response) => {
      this.clientSet = response.body;
    });
    this.apiHandler.getABCisRequest<Dataset[]>(ABCisApi.Support, 'channel/lookup').then((response) => {
      this.channelSet = response.body;
    });
    this.apiHandler.getABCisRequest<Dataset[]>(ABCisApi.Support, 'job/lookup').then((response) => {
      this.jobSet = response.body;
    });
    this.apiHandler.getABCisRequest<flowresponse[]>(ABCisApi.Support, 'client-channel-job/table?sf=clientId,channelId,jobId,bufferSize,isRunning&fr=0&rc=100').then((response) => {
      this.flow = this.getFlow(response.body);
    });
  }

  getFromSet(dataSet: Dataset[], val) {
    if (!dataSet || dataSet.length === 0) {
      return val;
    }

    const found = dataSet.find(x => x.value == val);
    return found ? found.label : val;
  }

  getFlow(response: flowresponse[]) : flowJob[] {
    const jobDictionary: { [s: number]: flowJob; } = {};
    response.forEach(jobFlow => {
      if (jobDictionary[jobFlow.jobId] === undefined && this.hasChannel(jobFlow.channelId)) {
        jobDictionary[jobFlow.jobId] = {
          id: jobFlow.jobId,
          clients: this.getClientFlow(response, jobFlow.jobId)
        };
        console.log(jobDictionary);
      }
    });
    return this.getDictionaryValues(jobDictionary);
  }

  getClientFlow(response: flowresponse[], jobId: number): flowClient[] {
    const clientDictionary: { [s: number]: flowClient; } = {};
    response.forEach(jobFlow => {
      if (jobFlow.jobId == jobId) {
        if (clientDictionary[jobFlow.clientId] === undefined && this.hasChannel(jobFlow.channelId)) {
          clientDictionary[jobFlow.clientId] = {
            id: jobFlow.clientId,
            channels: this.getChannelFlow(response, jobFlow.jobId, jobFlow.clientId)
          };
        }
      }
    });
    return this.getDictionaryValues(clientDictionary);
  }

  getChannelFlow(response: flowresponse[], jobId: number, clientId: number): flowChannel[] {
    const channelDictionary: { [s: number]: flowChannel; } = {};
    response.forEach(jobFlow => {
      if (jobFlow.jobId == jobId && jobFlow.clientId == clientId) {
        if (channelDictionary[jobFlow.channelId] === undefined && this.hasChannel(jobFlow.channelId)) {
          channelDictionary[jobFlow.channelId] = {
            id: jobFlow.channelId,
            buffer: jobFlow.bufferSize,
            isRunning: jobFlow.isRunning
          };
        }
      }
    });
    return this.getDictionaryValues(channelDictionary);
  }

  hasChannel(channelId: number): boolean {
    let isAllowed = false;
    this.allowedChannels.forEach(channel => {
      if (channelId == channel)
      {
        isAllowed = true;
        return;
      }
    });
    return isAllowed;
  }

  getDictionaryValues<T>(dictionary: { [s: string]: T; }): T[] {
    const ret: T[] = [];
    for (const key in dictionary) {
      ret.push(dictionary[key]);
    }
    return ret;
  }

  toggleChange(jobIndex, clientIndex, channelIndex) {
    const jobId = this.flow[jobIndex].id;
    const clientId = this.flow[jobIndex].clients[clientIndex].id;
    const channelId = this.flow[jobIndex].clients[clientIndex].channels[channelIndex].id;
    this.flow[jobIndex].clients[clientIndex].channels[channelIndex].isRunning = !this.flow[jobIndex].clients[clientIndex].channels[channelIndex].isRunning;
    const running = this.flow[jobIndex].clients[clientIndex].channels[channelIndex].isRunning;
    this.apiHandler.postABCisRequest(ABCisApi.Support, `client-channel-job/${clientId}/${channelId}/${jobId}?isRunning=${running}`).then((response) => {
      if (running) {
        this.toastr.success('Selected channel is now running');
      } else {
        this.toastr.warning('Selected channel is no longer running');
      }
    }).catch(response => {
      this.toastr.error(response.error);
    });
  }
}

class flowresponse {
  clientId: number;
  channelId: number;
  jobId: number;
  bufferSize: number;
  isRunning: boolean;
}

class flowJob {
  id: number;
  clients: flowClient[];
}

class flowClient {
  id: number;
  channels: flowChannel[];
}

class flowChannel {
  id: number;
  buffer: number;
  isRunning: boolean;
}
